import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import { headerSortingClasses, sortCaret } from "../../../_metronic/_helpers";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { useSelector } from "react-redux";
import { Stepper, Step } from "react-form-stepper";
import { selectProduct } from "../product/productSlice";
import {
  createChangeHandler,
  getValueStatus,
  optionStatus,
  paramsActiveType,
  paramsCalculationType,
  paramsYesNoType,
  showDialog,
  useForceUpdate,
} from "../../utility";
import CurrencyInput from "react-currency-input-field";
import Select from "react-select";

export const ModalBonus = ({
  show,
  setShow,
  showProduct,
  setShowProduct,
  targetNo,
  setIndex,
  tableData,
  setTableData,
  selectedRows,
  setSelectedRows,
  setTableDataBonus,
}) => {
  const { SearchBar } = Search;
  const dataProduct = useSelector(selectProduct);
  const forceUpdate = useForceUpdate();
  const [step, setStep] = useState(1);
  const [tableProduct, setTableProduct] = useState([]);
  const [type, setType] = useState("");
  const [bonusQty, setBonusQty] = useState("");
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (dataProduct.length > 0) {
      const initData = dataProduct.map((item, index) => ({
        ...item,
        no: index + 1,
      }));
      setTableProduct(initData);
    }
  }, [dataProduct]);

  const handleFinish = () => {
    if (!validateStep2()) {
      return;
    }

    const product = selectedRows.map((item) => ({
      ...item,
      is_apply_multiples: type,
      bonus_quantity: bonusQty,
      is_active: status,
    }));

    setTableData((prevData) => {
      const updatedData = prevData.map((item) => {
        if (item.no === targetNo) {
          const currentItems = item.special_discount_bonus_items || [];

          // Ambil ID yang sudah ada
          const existingProductIds = new Set(
            currentItems.map((p) => p.product_id)
          );

          // Filter hanya produk yang belum ada
          const uniqueNewProducts = product.filter(
            (p) => !existingProductIds.has(p.product_id)
          );

          // Jika tidak ada yang bisa ditambahkan, stop
          if (uniqueNewProducts.length === 0) {
            alert("All selected products are already in the bonus list.");
            return item; // Tidak perlu update apa pun
          }

          const newItems = [...currentItems, ...uniqueNewProducts];

          const updatedItems = newItems.map((item, idx) => ({
            ...item,
            no: idx + 1,
          }));

          return {
            ...item,
            special_discount_bonus_items: updatedItems,
          };
        }
        return item;
      });

      setTableDataBonus(
        updatedData.find((item) => item.no === targetNo)
          ?.special_discount_bonus_items || []
      );

      return updatedData;
    });

    // Reset state
    setSelectedRows([]);
    setStep(1);
    setType("");
    setBonusQty("");
    setStatus(null);
    handleClose();
    forceUpdate();
  };

  const handleClose = () => {
    setShow(false);
    setShowProduct(true);
  };

  const validateStep1 = () => {
    if (selectedRows.length === 0) {
      showDialog("Please select at least one product.");
      return false;
    }
    return true;
  };

  const validateStep2 = () => {
    if (type === undefined || type === null || type === "") {
      showDialog("Please select Apply Multiples !");
      return false;
    }

    if (status === null) {
      showDialog("Please select status !");
      return false;
    }

    if (!bonusQty || bonusQty <= 0) {
      showDialog("Please enter a valid quantity.");
      return false;
    }

    return true;
  };

  const handleNext = () => {
    let isValid = false;

    if (step === 1) isValid = validateStep1();
    else if (step === 2) isValid = validateStep2();

    if (isValid && step < 3) setStep(step + 1);
  };

  const handlePrev = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleChangeType = createChangeHandler(setType);
  const handleChangeStatus = createChangeHandler(setStatus);

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "Code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "Name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const onSelectRow = {
    mode: "checkbox",
    selected: tableProduct
      .filter((row) =>
        selectedRows.some(
          (selectedRow) => selectedRow.product_code === row.product_code
        )
      )
      .map((row) => row.no),
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, ...tableProduct]);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        setSelectedRows(
          selectedRows.filter(
            (selectedRow) => selectedRow.product_code !== row.product_code
          )
        );
      }
      return true;
    },
  };

  return (
    <Modal
      show={show}
      size="lg"
      dialogClassName="modal-70"
      onHide={() => handleClose()} // Pindahkan logika dari handleClose ke sini
    >
      <Modal.Header closeButton>
        <Modal.Title> Add Bonus Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stepper activeStep={step - 1} style={{ padding: "12px" }}>
          <Step label="Select Product" />
          <Step label="Input Quantity" />
        </Stepper>
        <hr />

        {step === 1 && (
          <div className="card-body pt-0 mt-5" style={{ overflowY: "scroll" }}>
            <ToolkitProvider
              keyField="no"
              data={tableProduct}
              columns={columns}
              search
            >
              {(props) => (
                <>
                  <Row>
                    <Col></Col>
                    <Col>
                      <div className="float-right">
                        <SearchBar
                          {...props.searchProps}
                          placeholder="Search .."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div style={{ overflowY: "auto", maxHeight: "400px" }}>
                    <BootstrapTable
                      striped
                      noDataIndication="Data Not Found"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      bordered={true}
                      {...props.baseProps}
                      selectRow={onSelectRow}
                    />
                  </div>
                </>
              )}
            </ToolkitProvider>
          </div>
        )}

        {step === 2 && (
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>
                    Apply Multiples <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    options={paramsYesNoType}
                    value={getValueStatus(type, paramsYesNoType)}
                    placeholder="Select ..."
                    onChange={handleChangeType}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>
                    Status <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    options={paramsActiveType}
                    value={getValueStatus(status, paramsActiveType)}
                    placeholder="Select ..."
                    onChange={handleChangeStatus}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>
                    Bonus Qty <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="number"
                    min="0" // Membatasi input agar tidak kurang dari 0
                    onChange={(e) => {
                      const value = Math.max(0, e.target.value);
                      setBonusQty(value);
                    }}
                    value={bonusQty}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleClose()}>
          Close
        </Button>
        {step > 1 && (
          <Button variant="outline-danger" onClick={handlePrev}>
            Previous
          </Button>
        )}
        {step < 2 ? (
          <Button variant="danger" onClick={handleNext}>
            Next
          </Button>
        ) : (
          <Button variant="success" onClick={handleFinish}>
            Finish
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
